module.exports = require("core-js/library/fn/json/stringify");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/json/stringify.js